import { ReactElement } from 'react'
import CommentsListPane from '@editor/components/CommentsListPane'
import ImageCardsListPane from '@editor/components/ImageCardsListPane'
import TablesListPane from '@editor/components/TablesListPane'
import { PlanViewPlanElementTab } from '../../constants'

interface Props {
  tab: PlanViewPlanElementTab
}

/**
 * List column of the "Tabellen" / "Kommentare" / "Plan-Bilder" tabs: the project's plan elements of
 * that kind, the same lists as the element list tabs of Tragwerksplanung.
 */
const PlanViewPlanElementList = ({ tab }: Props): ReactElement => {
  if (tab === 'tables') return <TablesListPane />
  if (tab === 'comments') return <CommentsListPane />
  return <ImageCardsListPane />
}

export default PlanViewPlanElementList
